import {
  getAccessTokenCookie,
  getApolloClient,
  getImpersonatedUserAccessTokenCookie,
  getImpersonatedUserRefreshTokenCookie,
  getRefreshTokenCookie,
} from '@netfront/common-library';

export const getHowlerApolloClient = () => {
  return getApolloClient({
    apiName: 'howler',
    projectId: process.env.REACT_APP_PROJECT_ID,
    tokens: {
      accessToken: getImpersonatedUserAccessTokenCookie() ?? getAccessTokenCookie() ?? '',
      refreshToken: getImpersonatedUserRefreshTokenCookie() ?? getRefreshTokenCookie() ?? '',
    },
  });
};

export const howlerClient = getHowlerApolloClient();
